// src/components/CacheIndicator.js
import React, { useState, useEffect } from 'react';
import dataCache from '../services/dataCache';
import './CacheIndicator.css';

const CacheIndicator = () => {
  const [cacheStatus, setCacheStatus] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateStatus = () => {
      const status = dataCache.getStatus();
      setCacheStatus(status);
      setIsVisible(status.length > 0);
    };

    // 每秒更新一次狀態
    const interval = setInterval(updateStatus, 1000);
    updateStatus();

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="cache-indicator">
      <div className="cache-indicator-header">
        <span className="cache-icon">🔄</span>
        <span className="cache-text">資料自動更新中</span>
      </div>
      {cacheStatus.map((status) => (
        <div key={status.key} className="cache-item">
          <span className="cache-key">{status.key}</span>
          <span className="cache-age">
            {Math.floor(status.age / 1000)}秒前
          </span>
          {status.autoRefresh && (
            <span className="cache-refresh-badge">自動刷新</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default CacheIndicator;
